import type {PublicMethodUtils} from '@wix/document-services-types'
import type {EnvironmentPublicAPI} from '@wix/document-services-public-types'
import {environment} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<EnvironmentPublicAPI> {
    return {
        methods: {
            env: {
                viewer: {
                    /**
                     * Returns the name of the viewer currently used by DS
                     */
                    getViewerName: publicMethodUtils.defineGetter(environment.getViewerName),

                    /**
                     * Returns the version of the viewer currently used by DS
                     */
                    getViewerVersion: publicMethodUtils.defineGetter(environment.getViewerVersion)
                },
                screen: {
                    getResolution: publicMethodUtils.defineGetter(environment.getScreenResolution)
                }
            }
        }
    }
}
